var map = {
	"./de/returnBtn.png": "T5u4",
	"./en/returnBtn.png": "1sjN",
	"./es/returnBtn.png": "rXjT",
	"./fr/returnBtn.png": "2jbS",
	"./ja/returnBtn.png": "NsnP",
	"./ko/returnBtn.png": "xvIm",
	"./pt/returnBtn.png": "yZxK",
	"./ru/returnBtn.png": "wGf0",
	"./tc/returnBtn.png": "QNzf",
	"./th/returnBtn.png": "DrHz"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Owsm";